import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import { useForm } from "vee-validate";
import { useErrors } from "@/utils/api-functions";
//@ts-ignore
import FormInput from "@/components/form/input.vue";
//@ts-ignore
import FormCheckbox from "@/components/form/checkbox.vue";
//@ts-ignore
import FormRadio from "@/components/form/radio.vue";
//@ts-ignore
import FormCombobox from "@/components/form/combobox.vue";
//@ts-ignore
import Submit from "@/components/form/submit.vue";
import * as Yup from "yup";
import { nl } from "yup-locales";
import { useApiStore } from "@/stores/api";


export default /*#__PURE__*/_defineComponent({
  props: {
    groups: { type: null, required: true, default: () => [] },
    tags: { type: null, required: true, default: "" },
    viewingDaysLabel: { type: String, required: true, default: "Kijkdagen" },
    viewingDays: { type: null, required: true, default: () => [] },
    mailchimpIds: { type: Array, required: true, default: () => [] },
    mailchimpGroupId: { type: String, required: true, default: "subscribers" },
    pageTitle: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { groups: any, tags: any, viewingDaysLabel: string, viewingDays: any, mailchimpIds: string[], mailchimpGroupId: string, pageTitle: string }



const apiErrors = useErrors();
const apiStore = useApiStore();

const success = ref(false);
const loading = ref(false);
const component = ref<HTMLDivElement>();

Yup.setLocale(nl);

const { handleSubmit, isSubmitting } = useForm({
    initialValues: {
        first_name: "",
        email: "",
        phone: "",
        viewing_days: [],
        terms: undefined,
        page_title: props.pageTitle,
        href: window.location.href,
        pathname: window.location.pathname,
        tags: props.tags,
        mailchimp_group_id: props.mailchimpGroupId,
        mailchimp_ids: props.mailchimpIds,
    },
    validationSchema: Yup.object({
        page_title: Yup.string(),
        first_name: Yup.string().required().label("Naam"),
        email: Yup.string().email().required().label("Email"),
        phone: Yup.string()
            .matches(/(((\+|00)3[12][ ]?(?:\(0\)[ ]?)?)|0){1}(4(60|[789]\d)\/?(\s?\d{2}\.?){2}(\s?\d{2})|(\d\/?\s?\d{3}|\d{2}\/?\s?\d{2})(\.?\s?\d{2}){2})/, "GSM is ongeldig")
            .required()
            .label("GSM"),
        mailchimp_ids: Yup.array().label("Mailchimp ids"),
        viewing_days: Yup.array().label(`${props.viewingDaysLabel} dagen`),
        tags: Yup.string().label("Tags"),
        terms: Yup.boolean().required("Je dient te bevestigen dat Laud deze gegevens mag gebruiken om je aanvraag te verwerken."),
        href: Yup.string().required(),
        mailchimp_group_id: Yup.string().label("Mailchimp group ids"),
        pathname: Yup.string().required(),
    }),
});

const successMessage = ref('Bedankt! We hebben uw bericht goed ontvangen. We nemen zo snel mogelijk contact met u op.');
const onSubmit = handleSubmit(async (values, { resetForm }) => {
    try {
        loading.value = true;

        let v: any = values as any;

        v.option_values = "";

        if (values.viewing_days && values.viewing_days.length > 0) {
            v.option_values = values.viewing_days.join(", ");
        }

        // @ts-ignore
        const res = await apiStore.submitViewingDays(v);

        // @ts-ignore
        if (window.hasOwnProperty("dataLayer") && dataLayer) {
            // @ts-ignore
            dataLayer.push({
                event: "cf7submission",
                formId: "1953",
                response: [
                    { name: "first_name", value: values.first_name },
                    { name: "email", value: values.email },
                    { name: "phone", value: values.phone },
                    { name: "href", value: window.location.href },
                    { name: "pathname", value: window.location.pathname },
                ],
            });
        }

        success.value = true;

        //@ts-ignore
        successMessage.value = res.message ?? "Bedankt! We hebben uw bericht goed ontvangen. We nemen zo snel mogelijk contact met u op.";

        setTimeout(resetForm, 500);
    } catch (error) {
        apiErrors.parse(error);
    } finally {
        loading.value = false;
    }
});

const __returned__ = { props, apiErrors, apiStore, success, loading, component, handleSubmit, isSubmitting, successMessage, onSubmit, FormInput, FormCheckbox, Submit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})